import React, { ReactNode } from "react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import './PageHeader.scss';

interface PageHeaderProps {
  title?: string;
  subtitle?: string | ReactNode;
  backAction?: () => void;
  children?: ReactNode;
  className?: string;
}

const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  subtitle,
  backAction,
  children,
  className = "",
}) => {
  return (
    <div className={`page-header ${className}`}>
      {/* <div className="navigation"> */}
        {backAction && (
          <ArrowBackIcon
            style={{ cursor: "pointer" }}
            onClick={backAction}
          />
        )}
        <div className="details">
          {title && <p className="title">{title}</p>}
          {subtitle && <p className="subtitle">{subtitle}</p>}
          {children}
        </div>
      {/* </div> */}
    </div>
  );
};

export default PageHeader;
